/** Ubicación real del club. Separado del mapa para no arrastrar maplibre al render inicial. */
export const LOCAL_LOCATION = {
  lat: 2.9268522,
  lng: -75.2866714,
  address: 'Cra. 7 #06-87, Neiva, Huila',
  name: 'Primera Riverada los 4 Ases',
  gmapsPin: 'https://maps.google.com/maps?q=2.9268522,-75.2866714',
  gmapsDir:
    'https://maps.google.com/maps/dir/?api=1&destination=2.9268522,-75.2866714',
} as const
